import React from 'react'
import BlueImmage from '@modul-connect/shared/img/blue_image_icon.svg'
import { MdDelete } from 'react-icons/md'
import { CircularProgress } from '@mui/material'
import { Link } from '@modul-connect/shared/components/atoms/text/text'
import View from '@modul-connect/shared/components/atoms/view'

export const UploadImagesView = ({
  sendRemoveImage,
  uplodedAssetsImage,
  openUploadImage,
  setOpenedAddImage,
  uplodedImageOfSerial,
  hasBeenUploadedSerialImage,
  setUplodedImageOfSerial,
  setUplodedAseetsImage,
  setOpenedAddImageOfSerial,
  hasBeenUploadedAssetImage,
  setModalForUploadingImage
}) => {
  const BlueImmageIcon = <img src={BlueImmage} />

  return (
    <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', gap: 15 }}>

      <View style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <Link
          underline
          icon={BlueImmageIcon}
          onClick={() => {
            openUploadImage(true)
            setOpenedAddImageOfSerial(false)
            setOpenedAddImage(true)
            setModalForUploadingImage('Asset')
          }}
        >{'Add image'}</Link>

        <ShowUploadedImageInfo
          uplodedImage={uplodedAssetsImage}
          enableDelete={hasBeenUploadedAssetImage}
          onClick={() => {
            setUplodedAseetsImage(null)
            sendRemoveImage(uplodedAssetsImage)
          }
          }
        />

      </View>

      <View style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <Link
          underline
          icon={BlueImmageIcon}
          onClick={() => {
            openUploadImage(true)
            setOpenedAddImage(false)
            setOpenedAddImageOfSerial(true)
            setModalForUploadingImage('Serial_id')
          }}
        >{'Add image of serial number'}</Link>

        <ShowUploadedImageInfo
          uplodedImage={uplodedImageOfSerial}
          enableDelete={hasBeenUploadedSerialImage}
          onClick={() => {
            setUplodedImageOfSerial(null)
            sendRemoveImage(uplodedImageOfSerial)
          }}
        />
      </View>
    </View>
  )
}


const ShowUploadedImageInfo = ({
  uplodedImage,
  onClick,
  enableDelete
}) => {
  return (
    <View >
      {
        uplodedImage?.name
          ?
          <View style={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
            <View style={{ display: 'inline-block', overflow: 'hidden' }}>
              {
                uplodedImage.name
              }
            </View>
            <View style={{ width: '30px' }}>
              {
                enableDelete
                  ? <MdDelete onClick={onClick} style={{ cursor: 'pointer' }} />
                  : <CircularProgress size={20} color="inherit" />
              }
            </View>
          </View>
          : null
      }
    </View>
  )
}